import React, { useState, useEffect } from "react";
import "./AccessControl.css";

const AccessControl = ({ onAccessGranted }) => {
  const [accessCode, setAccessCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  // Code d'invitation unique pour le groupe (MASQUÉ)
  const VALID_ACCESS_CODE = "COVOIT41";

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    // Simulation d'un délai pour l'UX
    setTimeout(() => {
      if (accessCode.trim().toUpperCase() === VALID_ACCESS_CODE) {
        // Accès accordé - sauvegarder en localStorage
        localStorage.setItem("covoiturage_access", "granted");
        onAccessGranted();
      } else {
        setError("Code incorrect. Demandez le code à votre assemblée.");
      }
      setIsLoading(false);
    }, 500);
  };

  // Vérifier si l'accès est déjà accordé
  useEffect(() => {
    const hasAccess = localStorage.getItem("covoiturage_access") === "granted";
    if (hasAccess) {
      onAccessGranted();
    }
  }, [onAccessGranted]);

  return (
    <div className="access-control">
      <div className="access-container">
        {/* Logo et titre */}
        <div className="access-header">
          <div className="access-logo">🚗</div>
          <h1 className="access-title">COVOITURAGE</h1>
          <p className="access-subtitle">Groupe privé</p>
        </div>

        {/* Formulaire de code */}
        <form onSubmit={handleSubmit} className="access-form">
          <div className="form-group">
            <label htmlFor="accessCode" className="form-label">
              Entrez le code secret :
            </label>
            <input
              type="text"
              id="accessCode"
              value={accessCode}
              onChange={(e) => setAccessCode(e.target.value)}
              placeholder="Code d'invitation"
              className="form-input"
              autoFocus
              disabled={isLoading}
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button
            type="submit"
            className="access-button"
            disabled={isLoading || !accessCode.trim()}
          >
            {isLoading ? "Vérification..." : "ACCÉDER"}
          </button>
        </form>

        {/* Instructions sans afficher le code */}
        <div className="access-hint">
          <p className="hint-text">
            Demandez le code d'accès à votre assemblée
          </p>
          <p className="hint-subtitle">
            Ce code est confidentiel et ne doit pas être partagé
          </p>
        </div>
      </div>
    </div>
  );
};

export default AccessControl;
